<template>
  <div class="person d-flex-v2">
    <div class="name">
      <p class="fs-14 color-grey-3 font-smoothing w-100">Indtast fulde navn på rejsende <span class="asterisk">*</span></p>
      <input class="w-50 fs-14 color-grey-3 outline-none" type="text" v-model.trim="data_person.firstName" placeholder="Fornavn(e)" @keypress="show_errors.firstName = false" :class="{'error-border' : show_errors.firstName}">
      <input class="w-50 fs-14 color-grey-3 outline-none" type="text" v-model.trim="data_person.lastName" placeholder="Efternavn" @keypress="show_errors.lastName = false" :class="{'error-border' : show_errors.lastName}">
    </div>
    <div class="d-flex">
      <div class="luggage-small">
        <p class="fs-14 color-grey-3 font-smoothing">Bagage</p>
        <input-number :number="data_person.luggageSmall" @setLuggage="setLuggage($event, 'luggageSmall')" @increment="addLuggage('luggageSmall')" @decrement="removeLuggage('luggageSmall')"/>
      </div>
      <div class="luggage-large">
        <p class="fs-14 color-grey-3 font-smoothing">Stor Bagage</p>
        <input-number :number="data_person.luggageLarge" @setLuggage="setLuggage($event, 'luggageLarge')" @increment="addLuggage('luggageLarge')" @decrement="removeLuggage('luggageLarge')"/>
      </div>
      <button
        v-if="moreThanOnePerson"
        type="button"
        class="remove-person"
        @click="removePerson(data_person.id)"
      >
        <i class="material-icons">
          close
        </i>
      </button>
    </div>
  </div>
</template>

<script>
import InputNumber from '@/components/InputNumber'
import { mapGetters, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'Person',
  components: {
    InputNumber
  },
  props: {
    data_person: { type: Object, required: true },
    index: { type: Number, required: true },
    moreThanOnePerson: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['cart']),
    ...mapFields([
      'shouldDisplayErrors'
    ]),
  },
  data() {
    return {
      show_errors: {
        firstName: false,
        lastName: false
      }
    }
  },
  watch: {
    shouldDisplayErrors(){
      this.setErrors();
    },
  },
  methods: {
    ...mapMutations([
      'distributeLuggage',
      'specificDistributedLuggage',
      'removePerson'
    ]),
    setLuggage(amount, luggageType) {
      this.specificDistributedLuggage({ id: this.data_person.id, type: luggageType, amount: amount })
    },
    addLuggage(prop) {
      this.distributeLuggage({ id: this.data_person.id, type: prop, to: 'person'})
    },
    removeLuggage(prop) {
      this.distributeLuggage({ id: this.data_person.id, type: prop, to: 'cart'})
    },
    setErrors(){
      this.show_errors.firstName = this.data_person.firstName.length === 0;
      this.show_errors.lastName = this.data_person.lastName.length === 0;
    },
  }
}
</script>

<style lang="scss">
  @use '../assets/scss/variables' as *;
  $break-small: 500px;
  $break-large: 1200px;

  .d-flex-v2{
    display: flex !important;
    @media screen and (max-width: $break-small) {
      display: block !important;
    }
  }
  .person {
    &:not(:last-child) {
      margin-bottom: 15px
    }

    input {
      border: 1px solid $grey-1;
      padding: 18.5px;
    }

    .name {
      width: calc(100% - 320px);
      padding-right: 15px;

      @media screen and (max-width: $break-small) {
        width: 100%;
        /*display: flex !important;*/
        margin: 0 0 10px 0;
      }

      input {
        &:last-child {
          margin-left: -1px;
        }
      }
    }

    .luggage-small {
      margin-right: 15px;
    }

    .luggage-small,
    .luggage-large {
      width: 120px;

      .input-number {
        height: 60px;

        input {
          width: 100%;
        }

        .increment,
        .decrement {
          height: 30px;
          padding: 8px 8px;
        }
      }
    }

    .remove-person {
      width: 60px;
      height: 60px;
      margin-left: 15px;
      margin-top: 37px;
      border: 1px solid $grey-1;
      flex-shrink: 0;
      cursor: pointer;
      /*position: relative;*/
      /*display: flex;*/
      // align-items: center;
      /*justify-content: center;*/
      // flex-direction: column;
    }

    .remove-person i {
      margin: auto;
      display: block;
    }

    /* IE style fix on button*/
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      .remove-person i {
        margin: 20px auto !important;
      }
    }
  }
</style>
